import Layout from '@layout/Index'

export const platformUserProvince = [
  {
    path: '/platform-user-province',
    component: Layout,
    children: [
      {
        path: 'update/:userid',
        component: () => import(/* webpackChunkName: "platform-user-province-form" */ './pages/platformUserProvinceForm.vue'),
        meta: {
          title: '分配用户资源详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform-user-province/platform-user-province.route.js